/* eslint-disable @typescript-eslint/no-explicit-any */
import { ReactNode } from 'react';
import { FeatureFlagsProviderLD } from 'modules/FeatureFlagsLD/FeatureFlagsProviderLD';
import { FeaturedFlagsProvider } from 'modules/FeaturedFlags/FeaturedFlagsProvider';
import KeyboardShortcutProvider from 'modules/KeyboardShortcuts/KeyboardShortcutContext';
import { TipPopoverProvider } from 'components/TipPopover/TipPopoverContext';

interface CoreProvidersProps {
  children: ReactNode;
  currentUser?: any;
  enabledFeatures?: any[];
}

export const CoreProviders = ({ children, currentUser, enabledFeatures = [] }: CoreProvidersProps) => {
  return (
    <FeatureFlagsProviderLD initialAuthData={currentUser}>
      <TipPopoverProvider>
        <FeaturedFlagsProvider enabledFeaturesMe={enabledFeatures}>
          <KeyboardShortcutProvider>{children}</KeyboardShortcutProvider>
        </FeaturedFlagsProvider>
      </TipPopoverProvider>
    </FeatureFlagsProviderLD>
  );
};
